import React from 'react';
import { defineMessage } from 'react-intl';
import GermanyFlag from 'assets/images/icons/germany_flag.svg';
import UkFlag from 'assets/images/icons/uk_flag.svg';
import SpainFlag from 'assets/images/icons/spain_flag.svg';

const supportedLanguages = [
  {
    prefix: 'DE',
    flagIcon: (
      <GermanyFlag
        data-testid="germany_flag"
        css="height: 16px; width: 16px; margin: 6px;"
      />
    ),
    name: defineMessage({ defaultMessage: 'German' }),
    active: true,
  },
  {
    prefix: 'EN',
    flagIcon: (
      <UkFlag
        data-testid="uk_flag"
        css="height: 16px; width: 16px; margin: 6px;"
      />
    ),
    name: defineMessage({ defaultMessage: 'English' }),
    active: true,
  },
  {
    prefix: 'ES',
    flagIcon: (
      <SpainFlag
        data-testid="spain_flag"
        css="height: 16px; width: 16px; margin: 6px;"
      />
    ),
    name: defineMessage({ defaultMessage: 'Spanish' }),
    active: true,
  },
];

export default supportedLanguages;
